import { createTheme } from "@mui/material/styles";

const headerTheme = createTheme({
  palette: {
    primary: {
      main: "#0d2532",
    },
    secondary: {
      main: "#08BBED",
    },
    text: {
      primary: "#ccddff",
      secondary: "#08BBED",
    },
  },
  
});
const mainTheme = createTheme({});

export { headerTheme, mainTheme };

